import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { get } from '@aws-amplify/api';
import awsconfig from './aws-exports';
import { printConsole } from './lib/utility';
import { downloadFile, uploadFile } from "./lib/common";
import './App.css';
import axios from 'axios';
import AppLayout from './components/AppLayout';

const AiAnalysis = ({ signOut }) => {
  const [securities, setSecurities] = useState("");
  const [aiPrompt, setAiPrompt] = useState("");
  const [data, setData] = useState({"securities": "", "aiPrompt": ""});
  const [aiMessage, setAiMessage] = useState("");
  const [error, setError] = useState('');
  const [hide, setHide] = useState("hidden");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  //let aiResponse = useRef("");
  const [aiResponse, setAiResponse] = useState(false);
  let mydata = useRef();
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    console.log("Executing useEffect");
    console.log("useEffect : data = " + JSON.stringify(data));
    console.log("useEffect : submitted = " + submitted);
    if (submitted) {
      const urlStringSecurities = jsonToUrlString(data.securities);
      console.log("useEffect : urlStringSecurities = " + urlStringSecurities);
      const urlStringAiPrompt = jsonToUrlString(data.aiPrompt);
      console.log("useEffect : urlStringAiPrompt = " + urlStringAiPrompt);
      getAiAnalysis(urlStringSecurities, urlStringAiPrompt);
    }
    
  }, [submitted, data]);

  useEffect(() => {
    console.log("Executing useEffect aiResponse");
    if (aiResponse && aiResponse !== false) { 
      console.log("useEffect : aiResponse = " + aiResponse);

      // Store the response in localStorage
      localStorage.setItem("aiResponse", aiResponse);

      // Navigate to /ai-response using react-router-dom
      navigate('/ai-response'); 
    }
  }, [aiResponse, navigate]);

  async function getAiAnalysis(securities, aiPrompt) {
    printConsole("Executing getAiAnalysis");
    const myAPI="mktappapi";
    //let path = '/chatgptanalysis'; 
    let path = 'https://suvwqdy6auawtblclctwciilcm0ezboe.lambda-url.us-east-1.on.aws';
    //var passApiStr=await path + "/" + securities + "/" + aiPrompt;
    let passApistr=path + "/?securities=" + securities + "&aiprompt=" + aiPrompt;
    await printConsole("getAiAnalysis : passApiStr = "+ passApistr);
    //await Promise.resolve(await get(myAPI, passApiStr))
    try {
      await Promise.resolve(await axios.get(passApistr))
        .then(async resp =>{
          await printConsole("getAiAnalysis : resp = ", resp);
          setAiResponse(await resp.data);
          await printConsole("getAiAnalysis : aiResponse = " + JSON.stringify(aiResponse));
          setAiMessage("");
          setError("");
      })
      .catch(error => {
        setError(error.message);
        printConsole("getAiAnalysis : Error = " + error.message);
      }) 
    } catch (error) {}
  }

  const jsonToUrlString = (json) => {
    const params = encodeURIComponent(JSON.stringify(json));
    return params.toString();
  };

  const handleSubmit = () => {
    setSubmitted(true);
    setAiMessage("AI Is Analyzing...");
    printConsole ("handleSubmit : securities = " + securities + "\taiPrompt = " + aiPrompt);
    setData({"securities": securities, "aiPrompt": aiPrompt});
  };


  return (
    <AppLayout signOut={signOut}>
      <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
            AI Analysis
          </h1>
          <p style={{ fontSize: '14px', color: 'rgba(107, 114, 128, 1)' }}>
            Get AI-powered insights on your securities
          </p>
        </div>

        {/* Loading/Status Message */}
        {aiMessage && (
          <div style={{
            padding: '12px',
            marginBottom: '24px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px',
            color: '#3b82f6',
            fontWeight: '500',
            textAlign: 'center'
          }}>
            {aiMessage}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div style={{
            padding: '12px',
            marginBottom: '24px',
            background: 'rgba(239, 68, 68, 0.1)',
            color: '#ef4444',
            borderRadius: '8px',
            fontWeight: '500',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        {/* Input Form Card */}
        <div style={{
          background: 'white',
          borderRadius: '12px',
          border: '1px solid rgba(229, 231, 235, 1)',
          padding: '32px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          <form id="aiAnalysisForm" name="aiAnalysisForm" onSubmit={(e) => e.preventDefault()}>
            {/* Securities Input */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: 'rgba(55, 65, 81, 1)'
              }}>
                Securities (comma-separated)
              </label>
              <input
                type="text"
                id="securities"
                name="securities"
                placeholder="e.g., AAPL, MSFT, GOOGL"
                value={securities}
                onChange={(e) => {setSecurities(e.target.value); setAiMessage("")}}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  fontSize: '14px',
                  border: '1px solid rgba(229, 231, 235, 1)',
                  borderRadius: '8px',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                  fontFamily: 'inherit'
                }}
              />
              <p style={{
                fontSize: '12px',
                color: 'rgba(107, 114, 128, 1)',
                marginTop: '6px',
                marginBottom: 0
              }}>
                Enter multiple securities separated by commas
              </p>
            </div>

            {/* AI Prompt Input */}
            <div style={{ marginBottom: '32px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: 'rgba(55, 65, 81, 1)'
              }}>
                AI Prompt
              </label>
              <textarea
                name="aiPrompt"
                placeholder="Enter your analysis question or prompt..."
                value={aiPrompt}
                onChange={(e) => {setAiPrompt(e.target.value); setAiMessage("")}}
                rows={6}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  fontSize: '14px',
                  border: '1px solid rgba(229, 231, 235, 1)',
                  borderRadius: '8px',
                  outline: 'none',
                  transition: 'border-color 0.2s',
                  fontFamily: 'inherit',
                  resize: 'vertical',
                  lineHeight: '1.5'
                }}
              />
              <p style={{
                fontSize: '12px',
                color: 'rgba(107, 114, 128, 1)',
                marginTop: '6px',
                marginBottom: 0
              }}>
                Describe what analysis you'd like to perform
              </p>
            </div>

            {/* Submit Button */}
            <button
              onClick={handleSubmit}
              type="button"
              style={{
                width: '100%',
                padding: '14px 24px',
                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 4px 6px rgba(59, 130, 246, 0.3)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(59, 130, 246, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(59, 130, 246, 0.3)';
              }}
            >
              Analyze with AI
            </button>
          </form>
        </div>

        {/* Info Card */}
        <div style={{
          marginTop: '24px',
          padding: '16px',
          background: 'rgba(59, 130, 246, 0.05)',
          borderRadius: '8px',
          border: '1px solid rgba(59, 130, 246, 0.2)',
        }}>
          <p style={{
            fontSize: '14px',
            color: 'rgba(55, 65, 81, 1)',
            margin: 0,
            lineHeight: '1.6'
          }}>
            <strong>Tip:</strong> Be specific in your prompt for better results. For example: "Compare the fundamental metrics of these companies" or "Analyze the growth potential based on recent earnings."
          </p>
        </div>
      </div>
    </AppLayout>
  );
};

export default AiAnalysis;
